import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Router, Link, Routes } from 'react-router-dom';
import Content from './content';
import PartnershipDeed from './partenshipdeed';
import Pvtltdcompanyregistration from './pvtltdcompanyregistration';
import Section8companyregistration from "./section8companyregistration";
import LLPcompanyregistration from "./llpcompanyregistration";
import OPCcompanyregistration from "./opccompanyregistration";
import Annualcompliancellp from "./annualcompliancellp";
import Annualcompliancepvtltd from "./annualcompliancepvtltd";
import Importexportlicenseieciec from "./importexportlicenseiec";
import MSMEregistration from "./msmeregistration";
import Gumastalicense from "./gumastalicense";
import Trademarkregistration from "./trademarkregistration";
import GSTregistration from "./gstregistration";
import Foodlicence from "./foodlicence";
import GSTreturnfiling from "./gstreturnfiling";
import Itrfiling from "./itrfiling";
import Tdsreturnfiling from "./tdsreturnfiling";
import Onlineaccounting from "./onlineaccounting";
import Legalnoticereply from "./legalnoticereply";
import Legalclaimhelp from "./legalclaimhelp";
import Legalnotice from "./legalnotice";
import Aboutcompany from "./aboutcompany";
import Services from "./services";
import ContactUs from "./contactus";
import TermsAndConditions from "./termsandconditions";
import PrivacyPolicy from "./privacypolicy";
import CookiePolicy from "./cookiepolicy";
import RefundPolicy from "./refundpolicy";
import ScrollToTop from './scrolltop';

import Header from "./header";

import Layout from "./Layout";
import ProtectedRoute from "./ProtectedRoute";
import UserServices from "./User/UserServicess";
import Profile from "./User/Profile";
import Orders from "./User/Orders";
import Invoice from "./User/Invoice";
import AgentForm from "./User/AgentForm";
import UserInvoices from "./User/Invoice";
import { Uploads } from "./User/Uploads";
import AgentSignupRequest from "./Agent/AgentSignupRequest";
import AgentProfile from "./Agent/agentProfile";
import AgentServices from "./Agent/AgentServicess";
import { AgentUploads } from "./Agent/AgentUploads";
import Bookservice from "./User/Bookservice";
import { ServicesProvider } from "../services/ServicesContext";
import CmaReport from "./New/CmaReport";
import TrustAndSociety from "./New/TrustAndSociety";
import ProfessionalTax from "./New/ProfessionalTax";
import PfAndEsicRegistration from "./New/PfAndEsicRegistration";
import BalanceSheetPL from "./New/BalanceSheetPL";
import PfEsicReturn from "./New/PfEsicReturn";
import DissolutionOfDeeds from "./New/DissolutionOfDeeds";
import AddressAmendmentLLP from "./New/AddressAmendmentLLP";
import AddressAmendmentCompany from "./New/AddressAmendmentCompany";
import AddressAmendmentOutOfStateCompany from "./New/AddressAmendmentOutOfStateCompany";
import AddressAmendmentOutOfStateLLP from "./New/AddressAmendmentOutOfStateLLP";
import AddDirectorCompany from "./New/AddDirectorCompany";
import AddPartnerCompany from "./New/AddPartnerCompany";
import IncreaseCapitalLLP from "./New/IncreaseCapitalLLP";
import IncreaseCapitalCompany from "./New/IncreaseCapitalCompany";
import ChangeNameLLP from "./New/ChangeNameLLP";
import RemoveDirectorCompany from "./New/RemoveDirectorCompany";
import RemovePartnerLLP from "./New/RemovePartnerLLP";
import ChangeNameCompany from "./New/ChangeNameCompany";
import Drafting from "./New/Drafting";
import CheckoutPage from "../services/CheckoutPage";
import UploadDocumentsPage from "../services/UploadDocumentsPage";
import SuccessPage from "../services/SuccessPage";
import AuthForm from "./User/AuthForm";
import ResetPassword from "../services/ResetPassword";






//
function Navbar() {









   return (


      <BrowserRouter>
         <ServicesProvider>
            <ScrollToTop />



            <Routes>

               <Route path="/" element={<Layout />}>


                  <Route path="/" element={<Content />} />
                  <Route path="/partnershipdeed" element={<PartnershipDeed />} />
                  <Route path="/pvtltdcompanyregistration" element={<Pvtltdcompanyregistration />} />
                  <Route path="/section8companyregistration" element={<Section8companyregistration />} />
                  <Route path="/llpcompanyregistration" element={<LLPcompanyregistration />} />
                  <Route path="/opccompanyregistration" element={<OPCcompanyregistration />} />
                  <Route path="/annualcompliancellp" element={<Annualcompliancellp />} />
                  <Route path="/annualcompliancepvtltd" element={<Annualcompliancepvtltd />} />

                  {/* Newpages */}

                  <Route path="/cmareport" element={<CmaReport />} />



                  <Route path="/dissolution-of-deeds" element={<DissolutionOfDeeds />} />
                  <Route path="/address-amendment-llp" element={<AddressAmendmentLLP />} />
                  <Route path="/address-amendment-company" element={<AddressAmendmentCompany />} />
                  <Route path="/address-amendment-outofstate-llp" element={<AddressAmendmentOutOfStateLLP />} />
                  <Route path="/address-amendment-outofstate-company" element={<AddressAmendmentOutOfStateCompany />} />
                 
                  <Route path="/add-director" element={<AddDirectorCompany />} />
                  <Route path="/add-partner" element={<AddPartnerCompany />} />
                  <Route path="/increase-capital-llp" element={<IncreaseCapitalLLP />} />
                  <Route path="/change-name-llp" element={<ChangeNameLLP />} />

                  <Route path="/remove-director" element={<RemoveDirectorCompany />} />
                  <Route path="/remove-partner" element={<RemovePartnerLLP />} />
                  <Route path="/increase-capital-company" element={<IncreaseCapitalCompany />} />
                  <Route path="/change-name-company" element={<ChangeNameCompany />} />

                  <Route path="/trust-and-society" element={<TrustAndSociety />} />
                  <Route path="/pf-and-esic" element={<PfAndEsicRegistration />} />
                  <Route path="/professionaltax" element={<ProfessionalTax />} />

                  <Route path="/pf-esic-return" element={<PfEsicReturn />} />
                  <Route path="/balancesheet" element={<BalanceSheetPL />} />


                  <Route path="/drafting" element={<Drafting />} />

                  {/* end */}


                  <Route path="/importexportlicenseiec" element={<Importexportlicenseieciec />} />
                  <Route path="/msmeregistration" element={<MSMEregistration />} />
                  <Route path="/gumastalicense" element={<Gumastalicense />} />
                  <Route path="/trademarkregistration" element={<Trademarkregistration />} />
                  <Route path="/gstregistration" element={<GSTregistration />} />
                  <Route path="/foodlicence" element={<Foodlicence />} />
                  <Route path="/gstreturnfiling" element={<GSTreturnfiling />} />
                  <Route path="/itrfiling" element={<Itrfiling />} />
                  <Route path="/tdsreturnfiling" element={<Tdsreturnfiling />} />
                  <Route path="/onlineaccounting" element={<Onlineaccounting />} />
                  <Route path="/legalnoticereply" element={<Legalnoticereply />} />
                  <Route path="/legalclaimhelp" element={<Legalclaimhelp />} />
                  <Route path="/legalnotice" element={<Legalnotice />} />
                  <Route path="/aboutcompany" element={<Aboutcompany />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/contactus" element={<ContactUs />} />
                  <Route path="/termsandconditions" element={<TermsAndConditions />} />
                  <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                  <Route path="/cookiepolicy" element={<CookiePolicy />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/user_services" element={<UserServices />} />
                  <Route path="/orders" element={<Orders />} />
                  <Route path="/invoice" element={<UserInvoices />} />
                  <Route path="/uploads" element={<Uploads />} />
                  <Route path="/refundpolicy" element={<RefundPolicy />} />
                  <Route path="/agentuploads" element={<AgentUploads />} />
                  <Route path="/agentservices" element={<AgentServices />} />
                  <Route path="/agentprofile" element={<AgentProfile />} />
                  <Route path="/bookservice" element={<Bookservice />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/upload-documents" element={<UploadDocumentsPage />} />
                  <Route path="/success" element={<SuccessPage />} />



               </Route>

               <Route path="/login" element={<AuthForm />} />
               <Route path="/agent-login" element={<AgentForm />} />
               <Route path="/reset-password/:token" element={<ResetPassword />} />


            </Routes>
         </ServicesProvider>
      </BrowserRouter>

   );
}


export default Navbar;